import { useAuth } from "@/context/AuthContext";
import KlardaLogo1 from "@/svg/KlardaLogo1";
import { Button, Divider } from "antd";
import { useTranslations } from "next-intl";
import HeaderActiveUser from "./HeaderActiveUser";
import KlardaProductsDropdown from "./KlardaProductsDropdown";

const GuestActions = () => {
  const t = useTranslations("home.header");
  const { openLoginModal } = useAuth();

  return (
    <>
      <HeaderActiveUser />
      <Divider type="vertical" className="h-8" />
      {/* <KlardaProductsDropdown /> */}
      {/* <Divider type="vertical" className="h-8" /> */}
      <Button
        type="primary"
        size="large"
        className="text-white border-none rounded-xl"
        onClick={() => openLoginModal()}
      >
        <div className="flex gap-2 items-center">
          <KlardaLogo1 /> {t("sign_in")}
        </div>
      </Button>
    </>
  );
};

export default GuestActions;

